// removed by extract-text-webpack-plugin
module.exports = {"detailContainer":"_2GNj5","detail_wrapper":"_3_9pr","xing":"_3osL-","mcTitle":"_1xyte","previewContainer":"tKBV8","iframe":"_3C_sC","previewImage":"_23q3n","emptyImage":"_3gjSE","imageLoaded":"_1fA8c _23q3n","mcInfo":"_3GJXx","mcDescription":"_1AFdO","backToOverviewWrap":"CiEnh","gridIconWrap":"_2lsek","social":"_2M58C","theme-round":"_36zZX","fa-spin":"_30SlO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/style.scss
// module id = L/1q
// module chunks = 0